
import { css } from "@emotion/react";
import {DIMENSIONS} from '@vc-workspace/utils-dimens';
import { Colors } from "@vc-workspace/utils-colors";

export const containerStyles = css({
  position: 'relative',
  textAlign: 'center'
});

export const prevNextBtnStyles = css({
  verticalAlign: 'middle',
  padding: `${DIMENSIONS.px_4} ${DIMENSIONS.px_16}`,
  border: `1px solid ${Colors.shady_lady}`,
  borderRadius: DIMENSIONS.px_4,
  '&:hover': {
    cursor: "pointer",
    background: Colors.white_lilac
  }
});

export const disabledPrevNextBtnStyles = css({
  '&:hover': {
    cursor: "default",
    background: Colors.white
  }
})

export const pageNumListStyles = css({
  display: "inline-block",
  marginLeft: DIMENSIONS.px_52,
  marginRight: DIMENSIONS.px_52
});

export const pageNumIconStyles = css({
  position: 'relative',
  verticalAlign: 'middle',
  display: "inline-block",
  width: DIMENSIONS.px_36,
  height: DIMENSIONS.px_36,
  borderRadius: '100%',
  background: Colors.white_lilac,
  textAlign: 'center',
  marginLeft: DIMENSIONS.px_8,
  marginRight: DIMENSIONS.px_8,
  '&:hover': {
    background: Colors.valhalla,
    cursor: 'pointer'
  }
});

export const selectedNumIconStyles = css({
  background: Colors.valhalla
});

export const pageNumStyles = css({
  position: 'absolute',
  top: '3px',
  left: '0px',
  right: '0px'
});